import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Home.css";

const stats = [
  { number: "50+", label: "Mandal Connected" },
  { number: "10K+", label: "Devotees Reached" },
  { number: "₹5L+", label: "Donations Collected" },
  { number: "20+", label: "Social Activities" },
];

const features = [
  {
    icon: "🏛️",
    title: "Mandal Directory",
    desc: "Find and connect with every registered Ganpati Mahotsav Mandal across Valsad district in one place.",
    link: "/sanstha",
  },
  {
    icon: "💝",
    title: "Make a Donation",
    desc: "Contribute to community celebrations and social causes. Every donation, big or small, creates an impact.",
    link: "/donate",
  },
  {
    icon: "🤝",
    title: "Social Activities",
    desc: "Join hands for blood donation drives, cleanliness campaigns, tree plantations & community welfare.",
    link: "/events",
  },
  {
    icon: "📋",
    title: "Register Your Mandal",
    desc: "Officially register your Ganpati Mahotsav Mandal and become part of our growing Valsad network.",
    link: "/register",
  },
];

const upcomingEvents = [
  {
    date: { day: "29", month: "Aug" },
    title: "Ganesh Chaturthi 2025 — Grand Celebration",
    location: "Valsad City, Gujarat",
    badge: "Major Event",
  },
  {
    date: { day: "15", month: "Jul" },
    title: "Blood Donation Camp",
    location: "Town Hall, Valsad",
    badge: "Social Drive",
  },
  {
    date: { day: "05", month: "Aug" },
    title: "Mandal Coordination Meet",
    location: "Community Centre, Valsad",
    badge: "Meeting",
  },
];

const testimonials = [
  {
    name: "Ramesh Patel",
    sanstha: "Shri Siddhivinayak Mandal, Valsad",
    text: "Aarambh has made it incredibly easy for us to connect with other mandal, coordinate volunteers and receive donations. A blessing for our community!",
    avatar: "🙏",
  },
  {
    name: "Priya Desai",
    sanstha: "Ganesh Utsav Mandal, Pardi",
    text: "The registration process was smooth and the platform helps us reach many more devotees. Truly a wonderful initiative for Valsad.",
    avatar: "🌸",
  },
  {
    name: "Mahesh Shah",
    sanstha: "Jai Ganesh Mahotsav, Bulsar",
    text: "We have been able to organise several social activities through Aarambh. The support from this platform is commendable.",
    avatar: "⭐",
  },
];

export default function Home() {
  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <div className="hero-bg-pattern" />
        <div className="container hero-content">
          <div className="badge">🕉 Valsad District</div>
          <h1 className="hero-title">
            Uniting the celebration <span className="hero-highlight">of Ganesh mahotsav</span>
          </h1>
          <p className="hero-subtitle">
            Aarambh is an online platform that connects people with true meaning of Sarvajanik Ganesh mahotsav Encouraging
            true cultural values , social welfare and seamless registration of the pandal
          </p>
          <div className="hero-actions">
            <Link to="/register" className="btn-primary">
              Register Mandal 📋
            </Link>
            <Link to="/donate" className="btn-outline">
              Donate Now 💝
            </Link>
          </div>

          <div className="hero-stats">
            {stats.map((s) => (
              <div key={s.label} className="hero-stat">
                <span className="stat-num">{s.number}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-ornament">
          <div className="om-circle">
            <span className="om-symbol">🕉</span>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">What We Do</div>
            <h2>One Platform, Many Connections</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
            <p>Aarambh brings together the spirit of devotion and community service under one roof.</p>
          </div>

          <div className="features-grid">
            {features.map((f) => (
              <Link to={f.link} key={f.title} className="feature-card card">
                <div className="feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
                <span className="feature-link">Learn more →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* About Strip */}
      <section className="about-strip">
        <div className="container about-strip-inner">
          <div className="about-strip-text">
            <div className="badge">Our Mission</div>
            <h2>Born from Devotion, Built for Community</h2>
            <p>
              Aarambh (आरंभ — meaning "The Beginning") was founded with a single vision: to unite every Ganpati Mahotsav
              Mandal in Valsad district so that together, we can celebrate Ganesh Utsav with greater joy, co-ordinate
              social activities and serve our community in Lord Ganesha's name.
            </p>
            <p>
              We believe that when mandal work together — sharing resources, volunteers and ideas — our celebrations
              become grander and our social impact becomes deeper.
            </p>
            <Link to="/about" className="btn-primary" style={{ marginTop: "16px", display: "inline-block" }}>
              Read Our Story
            </Link>
          </div>
          <div className="about-strip-visual">
            <div className="ganesha-card">
              <div className="ganesha-emoji">
                <img src={logo} alt="Aarambh" style={{ height: '80px', objectFit: 'contain' }} />
              </div>
              <blockquote>
                "Vakratunda Mahakaya, Surya Koti Sama Prabha — Nirvighnam Kuru Me Deva, Sarva Karyeshu Sarvada"
              </blockquote>
              <p className="shloka-translate">
                O Lord Ganesha, remove all obstacles from our path and bless every endeavour.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      <section className="events-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Upcoming</div>
            <h2>Events & Activities</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>

          <div className="events-list">
            {upcomingEvents.map((ev) => (
              <div key={ev.title} className="event-row card">
                <div className="event-date">
                  <span className="event-day">{ev.date.day}</span>
                  <span className="event-month">{ev.date.month}</span>
                </div>
                <div className="event-info">
                  <span className="event-badge">{ev.badge}</span>
                  <h3>{ev.title}</h3>
                  <p>📍 {ev.location}</p>
                </div>
                <Link to="/events" className="btn-outline" style={{ flexShrink: 0 }}>
                  View Details
                </Link>
              </div>
            ))}
          </div>

          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <Link to="/events" className="btn-primary">
              See All Events
            </Link>
          </div>
        </div>
      </section>

      {/* Donate CTA */}
      <section className="donate-cta">
        <div className="container donate-cta-inner">
          <div className="donate-cta-text">
            <h2>Your Donation Changes Lives</h2>
            <p>
              Support Ganesh Utsav celebrations, fund social activities and help underprivileged families in Valsad
              through your generous contribution.
            </p>
            <div className="donate-amounts">
              {["₹101", "₹501", "₹1,001", "₹5,001"].map((amt) => (
                <Link key={amt} to="/donate" className="amount-chip">
                  {amt}
                </Link>
              ))}
            </div>
          </div>
          <div className="donate-cta-action">
            <Link to="/donate" className="donate-big-btn">
              <span>🙏</span>
              <span>Donate Now</span>
            </Link>
            <p className="donate-note">100% transparent • All donations acknowledged</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Community Voices</div>
            <h2>What Our Members Say</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
          </div>

          <div className="testimonials-grid">
            {testimonials.map((t) => (
              <div key={t.name} className="testimonial-card card">
                <div className="testimonial-avatar">{t.avatar}</div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-author">
                  <strong>{t.name}</strong>
                  <span>{t.sanstha}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Register CTA */}
      <section className="register-cta">
        <div className="container" style={{ textAlign: "center" }}>
          <div className="badge">Join the Family</div>
          <h2>Register Your Mandal Today</h2>
          <p>
            Is your Ganpati Mahotsav Mandal based in Valsad? Get listed on our directory, receive donations and
            coordinate with other mandal — completely free.
          </p>
          <div style={{ display: "flex", gap: "16px", justifyContent: "center", marginTop: "28px", flexWrap: "wrap" }}>
            <Link to="/register" className="btn-primary">
              Register Now
            </Link>
            <Link to="/contact" className="btn-outline">
              Ask a Question
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
